import { TableCell, TableRow } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { EmissionRow } from './carbon-footprint-table-util'
import { useTableStyles } from '../../common/use-table-styles'
import { NO_MATCHING_RESOURCE_SYMBOL } from '../../common/constants'

type VersionValue = {
  versionId: string
  value: string
}

type Props = {
  versionValues: VersionValue[]
  handleEmissionClick: (
    versionId: string,
    row: EmissionRow,
    buildingName: string,
  ) => void
  row: EmissionRow
  buildingName: string
  unit: string
}

export function BreakdownTableRow(props: Props): React.ReactElement {
  const {
    versionValues: rowItems,
    handleEmissionClick,
    row,
    buildingName,
    unit,
  } = props
  const classes = useTableStyles()
  const { t } = useTranslation()

  return (
    <TableRow>
      <TableCell className={classes.indented}>{`${t(
        `emissionType.${row.emissionType}`,
      )}, ${unit}`}</TableCell>
      {rowItems.map((rowItem, index) =>
        rowItem.value === NO_MATCHING_RESOURCE_SYMBOL ? (
          <TableCell
            key={`breakdown-${rowItem.value}-${index.toString()}`}
            align="center"
          >
            {rowItem.value}
          </TableCell>
        ) : (
          <TableCell
            key={`breakdown-${rowItem.value.toString()}-${index.toString()}`}
            className={classes.editableCell}
            align="center"
            onClick={() =>
              handleEmissionClick(rowItem.versionId, row, buildingName)
            }
          >
            {rowItem.value}
          </TableCell>
        ),
      )}
    </TableRow>
  )
}
